<template>
  <div class="full-window">
    <SurveyChat class="sidebar-padding" />
  </div>
</template>

<script>
import { auth } from "@/firebase";
import SurveyChat from "@/components/survey/SurveyChat";
export default {
  name: "SurveyEmbed",
  components: {
    SurveyChat,
  },
  mounted() {
    auth.onAuthStateChanged(async (user) => {
      if (!user) {
        auth.signInAnonymously();
      }
    });
  },
};
</script>

<style scoped>
.full-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  z-index: 2000;
}
.sidebar-padding {
  padding: 16px 32px;
  width: 100%;
}
</style>
